export const LOADING_STATE = 'LOADING';
export const LOADING_SILENT_STATE = 'LOADING_SILENT';
export const ERROR_STATE = 'ERROR';

export type TDataState =
    typeof LOADING_STATE | typeof LOADING_SILENT_STATE | typeof ERROR_STATE | '';
